// Readable addresses for the category and city browse pages:
//   /category/<category slug>   and   /city/<city name, e.g. "sydney">
// The API resolves the same slugs (cheesta-api/src/index.ts, seoCityPathSlug) -
// keep the two in step.

const slugify = (value: string): string =>
    String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

/** "Gold Coast" -> "gold-coast". Falls back to the stored slug for non-Latin names. */
export const cityPathSlug = (city: { name: string; slug?: string }): string =>
    slugify(city.name) || city.slug || '';

export const categoryPath = (category: { slug: string }): string => `/category/${category.slug}`;
export const cityPath = (city: { name: string; slug?: string }): string => `/city/${cityPathSlug(city)}`;

// Persian city names for headings and page titles (addresses stay English).
// A city not listed here is shown under its stored name.
const CITY_NAME_FA: Record<string, string> = {
    sydney: 'سیدنی',
    melbourne: 'ملبورن',
    brisbane: 'بریزبن',
    adelaide: 'آدلاید',
    perth: 'پرت',
    'gold-coast': 'گلد کوست',
    canberra: 'کانبرا',
    newcastle: 'نیوکاسل',
    wollongong: 'ولونگونگ',
    southport: 'ساوت‌پورت',
    darwin: 'داروین',
    hobart: 'هوبارت',
    tasmania: 'تاسمانی',
};

export const cityDisplayName = (city: { name: string; slug?: string }): string =>
    CITY_NAME_FA[cityPathSlug(city)] || city.name;
